import { render, staticRenderFns } from "./SGRoleSummary.vue?vue&type=template&id=0626b599"
import script from "./SGRoleSummary.vue?vue&type=script&lang=js"
export * from "./SGRoleSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports